"use strict";
// returns tape inputs to the given node
// this looks at the direct inputs
// and if direct inputs is opeartion it looks into
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOperationAndTapes = exports.getSourceTapes = void 0;
const common_1 = require("@finley-technologies/common");
const uiNodes_1 = require("./uiNodes");
const utils_1 = require("./utils");
// returns input tapes to the given node.
// it looks at direct input tapes, and also
// indirect (via operation) input tapes.
const getSourceTapes = ({ node, graph, }) => {
    const inputNodes = (0, utils_1.getSourceNodes)({ node, graph });
    const srcTapes = inputNodes
        .map((srcNode) => {
        const uiNode = (0, uiNodes_1.getUINodeByType)(srcNode.metadata.tapeBuilderNodeType);
        if (uiNode.isOperation) {
            const operationInputs = (0, exports.getSourceTapes)({
                node: srcNode,
                graph,
            });
            return operationInputs;
        }
        return uiNode.getTapeNode(srcNode);
    })
        .flat()
        .filter(common_1.typeguards.isNotNullOrUndefined);
    return srcTapes;
};
exports.getSourceTapes = getSourceTapes;
const getOperationAndTapes = ({ node, graph, }) => {
    const inputNodes = (0, utils_1.getSourceNodes)({ node, graph });
    const operations = inputNodes.filter((srcNode) => {
        const uiNode = (0, uiNodes_1.getUINodeByType)(srcNode.metadata.tapeBuilderNodeType);
        return uiNode.isOperation;
    });
    (0, common_1.finleyAssert)(operations.length <= 1, `only 1 or 0 operations were expected. found ${operations.length}`);
    let operationNode = null;
    if (operations.length === 1) {
        const operationUINode = (0, uiNodes_1.getUINodeByType)(operations[0].metadata.tapeBuilderNodeType);
        (0, common_1.finleyAssert)(operationUINode.isOperation, 'expected all srcTapes to be tape nodes');
        operationNode = operationUINode.getOperationNode(operations[0]);
    }
    // in there was an operatin node, it must be the only inputNode.
    (0, common_1.finleyAssert)(operationNode === null || inputNodes.length === 1, 'expected just 1 input operation node');
    const srcTapes = operationNode
        ? (0, utils_1.getSourceNodes)({ node: operationNode, graph })
        : inputNodes;
    // we expect all srcTapes to be tape nodes
    const tapeNodes = srcTapes.map((srcNode) => {
        const uiNode = (0, uiNodes_1.getUINodeByType)(srcNode.metadata.tapeBuilderNodeType);
        (0, common_1.finleyAssert)(!uiNode.isOperation, 'expected all srcTapes to be tape nodes');
        return uiNode.getTapeNode(srcNode);
    });
    return {
        operationNode,
        srcTapes: tapeNodes,
    };
};
exports.getOperationAndTapes = getOperationAndTapes;
//# sourceMappingURL=conversionUtils.js.map